// Add your custom JS here!!!


// Set top level items to clickable
// Capabilities
jQuery(document).ready(function () {
  // Target the parent menu item by class name and add a click event
  jQuery(".top-level-cap").on("click", function () {
    // Replace 'your-link-url' with the URL you want to navigate to
    window.location.href = "/capabilities/";
  });
});

// About
jQuery(document).ready(function () {
  // Target the parent menu item by class name and add a click event
  jQuery(".top-level-about").on("click", function () {
    // Replace 'your-link-url' with the URL you want to navigate to
    window.location.href = "/about/";
  });
});

// Industries
jQuery(document).ready(function () {
  // Target the parent menu item by class name and add a click event
  jQuery(".top-level-ind").on("click", function () {
    // Replace 'your-link-url' with the URL you want to navigate to
    window.location.href = "/industries/";
  });
});